var map = {
	"../../pages/alarm/alarm.module": [
		"./src/app/pages/alarm/alarm.module.ts",
		"pages-alarm-alarm-module"
	],
	"../../pages/convoy/convoy.module": [
		"./src/app/pages/convoy/convoy.module.ts",
		"default~pages-convoy-convoy-module~pages-reports-reports-module",
		"default~pages-convoy-convoy-module~pages-driver-driver-module",
		"pages-convoy-convoy-module"
	],
	"../../pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"default~pages-dashboard-dashboard-module~pages-reports-reports-module",
		"pages-dashboard-dashboard-module"
	],
	"../../pages/driver/driver.module": [
		"./src/app/pages/driver/driver.module.ts",
		"default~pages-convoy-convoy-module~pages-driver-driver-module",
		"pages-driver-driver-module"
	],
	"../../pages/reports/reports.module": [
		"./src/app/pages/reports/reports.module.ts",
		"default~pages-dashboard-dashboard-module~pages-reports-reports-module",
		"default~pages-convoy-convoy-module~pages-reports-reports-module",
		"pages-reports-reports-module"
	],
	"../../pages/routes-generator/routes-generator.module": [
		"./src/app/pages/routes-generator/routes-generator.module.ts",
		"default~layout-admin-layout-admin-layout-module~pages-routes-generator-routes-generator-module",
		"pages-routes-generator-routes-generator-module"
	],
	"./layout/admin-layout/admin-layout.module": [
		"./src/app/layout/admin-layout/admin-layout.module.ts",
		"default~layout-admin-layout-admin-layout-module~pages-routes-generator-routes-generator-module",
		"layout-admin-layout-admin-layout-module"
	],
	"./layout/white-layout/white-layout.module": [
		"./src/app/layout/white-layout/white-layout.module.ts",
		"layout-white-layout-white-layout-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;